import { OgpSidebarItems } from './ogp-sidebar-items.types';

export const filterCollegialLendingSidebarItems = (
  sidebarItems: OgpSidebarItems,
  allowCollegialLending: boolean
): OgpSidebarItems => {
  if (allowCollegialLending) {
    return sidebarItems;
  }

  return sidebarItems.filter(
    (section) => section.key !== 'client-management' && section.key !== 'supplier-management'
  );
};
